import {Brick, registerBrick} from 'olympe';

/**
 * The Set constructor creates Set objects.
 */
export default class CreateSet extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {*} iterable
     * @param {function()} forwardEvent
     * @param {function(Set)} setSet
     */
    update($, [iterable], [forwardEvent, setSet]) {
        // Check if the object is an iterable
        if (iterable == null || !(typeof iterable[Symbol.iterator] === 'function')) {
            setSet(new Set());
        } else {
            setSet(new Set(iterable));
        }
        forwardEvent();
    }
}

registerBrick('018a6f10e1bf0a2b49da', CreateSet);
